import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const SPECIALTIES = [
  {
    title: "Windows",
    sub: "Replacement & New Install",
    text: "Energy-efficient, code-compliant window replacement and new installations — vinyl, aluminum and wood-clad options to match your home.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    cta: "Get a Window Quote",
    source: "specialties_windows",
  },
  {
    title: "Doors",
    sub: "Entry, Interior & Sliding",
    text: "Modern entry doors, interior swing & barn doors, sliding glass and patio systems — installed clean with new framing and trim where needed.",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c",
    cta: "Talk Door Options",
    source: "specialties_doors",
  },
  {
    title: "Kitchen Remodels",
    sub: "Full Kitchen Renovations",
    text: "Cabinets, countertops, appliances, lighting and finishes — designed and built around how your family actually uses the kitchen.",
    image: "https://images.pexels.com/photos/10827358/pexels-photo-10827358.jpeg",
    cta: "Start Your Kitchen",
    source: "specialties_kitchen",
  },
];

export default function FeaturedSpecialties() {
  return (
    <section data-testid="featured-specialties" className="section-pad">
      <div className="container-page">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <p className="overline mb-3">Also doing</p>
            <h2 className="heading-2">Windows, doors & kitchen remodels.</h2>
          </div>
          <div className="md:col-span-7 md:pt-6">
            <p className="body-base">
              In addition to ADUs, plumbing, HVAC and full construction, our team handles the day-to-day
              upgrades that transform how a home looks and lives. Beautiful windows, modern doors, and
              kitchen remodels that get used — not just photographed.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {SPECIALTIES.map((s, i) => (
            <Link
              key={s.title}
              to={`/contact?service=${encodeURIComponent(s.title)}`}
              data-testid={`specialty-${s.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="group relative overflow-hidden rounded-md border border-brand-line bg-white"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <p className="overline">{s.sub}</p>
                <h3 className="heading-3 mt-2">{s.title}</h3>
                <p className="body-sm mt-3">{s.text}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.2em] text-brand-ink group-hover:text-brand-olive-hover transition-colors">
                  {s.cta} <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
